import React from "react";
import { vibesColors as colors } from "../../theme/vibesColors";

function money(v) {
  const n = Number(v || 0);
  return `$${n.toFixed(2)}`;
}

export default function PricingSummaryCard({
  loading,
  error,
  isTableBooking,
  isBottleServiceBooking,
  isClubBooking,
  pricing,
  membersCount,
  bookingDays,
}) {
  return (
    <div className="review-price-list">
      {loading ? (
        <div className="review-row">
          <span>Loading summary...</span>
          <strong>...</strong>
        </div>
      ) : null}
      {error ? (
        <div className="review-row">
          <span style={{ color: colors.red }}>{error}</span>
          <strong />
        </div>
      ) : null}
      {isBottleServiceBooking ? (
        <>
          <div className="review-row">
            <span>Bottle service total</span>
            <strong>{money(pricing.bottleServiceTotal)}</strong>
          </div>
          <div className="review-row">
            <span>Alcoholic total</span>
            <strong>{money(pricing.alcoholicTotal)}</strong>
          </div>
          <div className="review-row">
            <span>Non-alcoholic total</span>
            <strong>{money(pricing.nonAlcoholicTotal)}</strong>
          </div>
        </>
      ) : !isTableBooking ? (
        <div className="review-row">
          <span>{`Entry Fee (${membersCount} members x ${bookingDays} days)`}</span>
          <strong>{money(pricing.entryFeeAmount)}</strong>
        </div>
      ) : null}
      {!isBottleServiceBooking ? (
        <div className="review-row">
          <span>{`Ticket Price (${membersCount} members x ${bookingDays} days)`}</span>
          <strong>{money(pricing.ticketPrice)}</strong>
        </div>
      ) : null}
      <div className="review-row">
        <span>Discount</span>
        <strong className={pricing.discount > 0 ? "review-discount-amount" : ""}>
          {pricing.discount > 0 ? `-${money(pricing.discount)}` : money(pricing.discount)}
        </strong>
      </div>
      <div className="review-row">
        <span>Taxes</span>
        <strong>{money(pricing.hst)}</strong>
      </div>
      <div className="review-row">
        <span>Platform Fee</span>
        <strong>{money(pricing.platformFee)}</strong>
      </div>
      {!isClubBooking ? (
        <div className="review-row">
          <span>{`Gratuity${pricing.gratuityPercent ? ` (${pricing.gratuityPercent}%)` : ""}`}</span>
          <strong>{money(pricing.gratuityAmount)}</strong>
        </div>
      ) : null}
      <div className="review-total-row">
        <span>Total</span>
        <strong>{money(pricing.total)}</strong>
      </div>
    </div>
  );
}
